$(function () {
  // Autorun angular module `lf.desktop`
  // if there is no [ng-app] attr defined in html
  autorunNgApp();
  
  $(document).on('click', 'a', function (e) {
    var href = $(this).attr('href');
    if (!href || href === '#') {
      e.preventDefault();
      e.stopPropagation();
    }
  });
  
  if ('ontouchstart' in window) {
    $('html').addClass('touch');
  }
  
  // Fix for iOS 8.x initial scale issue on CQ pages
  // See https://jira.leapfrog.com/browse/ECOMM-15813
  ;(function () {
    var iOS = (function () {
      var m = navigator.userAgent.match(/ip(ad|od|hone).+OS (\d+)_(\d+)_?(\d+)?/i);
      if (m) {
        return {
          version: { major: +m[2], minor: +m[3] }
        }
      }
      return null;
    })();

    if (iOS) {
      $('body').addClass('ios');
      
      if (iOS.version.major <= 8) {
        // Fixes CQ pages meta[viewport] value for iOS <= 8
        ;(function () {
          var $initialViewport = $('meta[name="viewport"]');
          var content = $initialViewport.prop('content');
          if (content !== 'width=device-width') {
            $initialViewport.remove();
            var $viewport = $('<meta name="viewport" content="width=device-width" />');
            $('head').append($viewport);
          }
        })();
      }
    }
  })();
  
  // Temp fix for ECOMM-17071 (Order confirmation page)
  ;(function () {
    if (/\/checkout\/confirmation\.jsp/.test(location.pathname)) {
      var $table = $('<table></table>');
      $table.css({
        'border-spacing': '0',
        'border-collapse': 'collapse',
        'width': 'auto',
        'min-width': '0',
        'max-width': 'none'
      });

      var $paymentMethodBlock = $('#orderDetails > hr ~ .row.section');
      $paymentMethodBlock.find('> p:first')
        .css({'margin-bottom': '5px'});

      $paymentMethodBlock.find('> .row').each(function () {
        var $row = $(this);
        var $orderTotal = $row.find('> p > .order-total');
        var price = $orderTotal.html();
        $orderTotal.remove();
        var name = $row.find('> p').html();

        var $tr = $('<tr></tr>');
        var $tdName = $('<td></td>').css({'padding': '0 20px 2px 0'}).html(name);
        var $tdPrice = $('<td></td>').css({'padding': '0 0 2px 0'}).html(price);
        $tr.append($tdName).append($tdPrice);
        $table.append($tr);
      });

      if ($table.find('tr').length) {
        $paymentMethodBlock.find('> .row').remove();
        $paymentMethodBlock.append($table);
      }
    }
  })();

  if (lf.data.xhr.client.isLFC) {
    var spinnerSrc = lf.data.xhr.assetsPath + '/legacy-assets/img/spinner-green-48x48.gif';
    var $pageLoadingOverlay = $('<div id="lfc-page-loading-overlay"></div>');
    var $spinner = $('<img class="lfc-page-loading-overlay__spinner" src="' + spinnerSrc + '" />');
    
    $pageLoadingOverlay
      .append($spinner)
      .hide()
      .appendTo('body');

    $(window).on('beforeunload', function (e) {
      $pageLoadingOverlay.show();
    });
    
    $(window).on('unload', function () {
      $('#lfc-page-loading-overlay').remove();
    });
  }
  
});

function autorunNgApp () {
  var $ngApp = $('[ng-app]');
  
  if ($ngApp.length) return;

  var $runNgApp = $('[data-run-ng-app]');
  if ($runNgApp.length && $runNgApp.data('run-ng-app') === false) {
    return;
  }
  
  var $html = $('html');
  $html
    .attr('id', 'lf.desktop')
    .attr('ng-app', 'lf.desktop')
    .attr('ng-controller', 'AppCtrl')
    .attr('data-ng-app-run-mode', 'auto');
  
  angular.bootstrap($html[0], ['lf.desktop']);
  
};

;(function () {
  // Temp fix for ECOMM-18647
  if (window.lf) {
    var data = lf && lf.data;
    var xhr =  data && data.xhr;
    var client = xhr && xhr.client;
    var isGuest = xhr && xhr.user && xhr.user.isGuest;
    
    var locales = 'en-us en-ca en-gb en-ie en-au en-oe';
    var locale = (function () {
      var siteBaseUrl = xhr.siteBaseUrl || '';
      var m = siteBaseUrl.match(/\/([a-z]{2}-[a-z]{2})\//i);
      return (m && locales.indexOf(m[1]) > -1) ? m[1] : null;
    })();

    if (locale && client && client.mode === 'mobile') {
      $.extend(xhr.client, {
        isDesktop: true,
        isDevice: false,
        isLFC: false,
        isMobile: false,
        layout: 'desktop',
        mobileUI: false,
        mode: 'web'
      });
      
      if (data.i18n && !data.i18n.header) {
        var str = {
          'en-us': {
            logIn: 'Log In / Register',
            myAccount: 'My Account',
            softgoodsCart: 'App Center',
            wishlist: 'My Wishlist'
          }
        };
        
        ['en-ca', 'en-gb', 'en-ie', 'en-au', 'en-oe'].forEach(function (locale) {
          str[locale] = $.extend({}, str['en-us']);
        });
        str['en-gb'].softgoodsCart = str['en-ie'].softgoodsCart = str['en-au'].softgoodsCart = 'App Centre';

        data.i18n.header = {
          myAccount: (isGuest ? str[locale].logIn : str[locale].myAccount),
          softgoodsCart: str[locale].softgoodsCart,
          wishlist: str[locale].wishlist,
          hardgoodsCart: ''
        };
      }
    }
  }

})();
